import React, { Component } from 'react';
import toast from 'react-hot-toast';
import { Call } from 'sushiweb/Icons';
import { grey } from 'sushiweb/tokens/color';
import { wfhModel } from '../../../api';
import { getFormData } from '../../commons/CommonMethods';
import {
  CALLBACK_EVENTS,
  sendCallbackApiEvents,
  sendCallbackModalEvents,
} from '../../../helpers/analytics/callback.analytics';
import { riderRoles } from '../../popups/RiderAssignments/RiderAssignments';
import { MetricsForJumboEvent } from '../../../analytics/constants';
import { ToolTip } from '../../ComponentsV1/ToolTip/Tooltip';
import { Confirm } from '../../../UiKit';
export default class WFHCall extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showWfhPop: false,
      isDisabled: false,
      selectedOption: null,
      callAlertData: null,
      loader: false,
    };
    this.timerID = null;
  }

  componentWillUnmount = () => {
    clearTimeout(this.timerID);
  };

  shouldComponentUpdate = (preProps, preState) => {
    if (
      !preState.callAlertData &&
      !this.state.callAlertData &&
      preState.callAlertData === this.state.callAlertData
    )
      return false;
    return true;
  };

  showWfhCallPop = () => {
    const {
      calledTo,
      orderId,
      userId,
      role = '',
      isNewUser = false,
      isResoAssistFlow = false,
      isCallingDisabled = false,
    } = this.props;

    if (isCallingDisabled) return;

    let params = {};
    params['order_id'] = orderId;
    params['called_to'] = calledTo;
    if (isNewUser) {
      params['user_id'] = userId;
    }
    params['is_reso_assist_flow'] = isResoAssistFlow;

    return wfhModel
      .getCallAlertData(params)
      .then((res) => {
        if (!res || (res && res.isError)) {
          sendCallbackApiEvents(
            CALLBACK_EVENTS.CALL_ALERT_DETAILS_FAILURE,
            orderId,
            userId,
            { called_to: calledTo, role: role ?? '' },
          );

          this.openToast(
            false,
            res.message || 'Something went wrong',
            'error',
            false,
          );
          return;
        }
        sendCallbackApiEvents(
          CALLBACK_EVENTS.CALL_ALERT_DETAILS_SUCCESS,
          orderId,
          userId,
          { called_to: calledTo, role: role ?? '' },
        );
        this.setState({
          showWfhPop: true,
          callAlertData: res && res.data && res.data.make_call_popup,
        });
      })
      .catch(() =>
        sendCallbackApiEvents(
          CALLBACK_EVENTS.CALL_ALERT_DETAILS_FAILURE,
          orderId,
          userId,
          { called_to: calledTo, role: role ?? '' },
        ),
      );
  };

  closeWfhPop = () => {
    const { orderId, userId, calledTo, role } = this.props;
    sendCallbackModalEvents(
      CALLBACK_EVENTS.CALLBACK_MODAL_CLOSE,
      orderId,
      userId,
      { called_to: calledTo, role: role ?? '' },
    );
    this.setState({
      showWfhPop: false,
      callAlertData: null,
    });
  };

  openToast = (showWfhPop, toastText, toastType, isDisabled) => {
    this.setState({
      showWfhPop: showWfhPop,
      isDisabled: isDisabled,
      loader: false,
    });

    if (toastType === 'success') {
      toast.success(toastText);
    } else {
      toast.error(toastText);
    }
  };

  handleClick = (action, content) => {
    if (action === 'cancel') {
      return this.closeWfhPop();
    }
    if (content.type === 'REDIRECT') {
      return this.redirectMakeCall();
    }
    return this.makeCall();
  };

  redirectMakeCall = () => {
    const { orderId, userId, calledTo, role, isNewUser } = this.props;
    const { selectedOption, callAlertData } = this.state;
    let data = {},
      radioData = {};
    data['order_id'] = orderId;
    if (isNewUser) {
      data['user_id'] = userId;
    }

    radioData =
      callAlertData &&
      callAlertData.radio &&
      getFormData(callAlertData.radio, selectedOption);

    Object.assign(data, radioData);

    this.setState({
      isDisabled: true,
      loader: true,
      callAlertData: null,
    });

    this.timerID = setTimeout(() => {
      return wfhModel
        .redirectMakeCall(data)
        .then((res) => {
          sendCallbackApiEvents(
            CALLBACK_EVENTS.REDIRECT_CALLBACK_SUCCESS,
            orderId,
            userId,
            { called_to: calledTo, role: role ?? '' },
          );
          this.setState({
            callAlertData: res && !res.isError ? res : null,
            showWfhPop: true,
            isDisabled: false,
            loader: false,
          });
        })
        .catch(() => {
          sendCallbackApiEvents(
            CALLBACK_EVENTS.REDIRECT_CALLBACK_FAILURE,
            orderId,
            userId,
            { called_to: calledTo, role: role ?? '' },
          );
        });
    }, 1000);
  };

  makeCall = () => {
    const {
      orderId,
      userId,
      isOfse = false,
      isUser = false,
      isAltContact = false,
      calledTo = 'Customer',
      calledToType = null,
      role = '',
      valetId = null,
      isNewUser,
      sendJumboEvent = false,
      jumboEventFunc = null,
      JumboEventProperties = null,
      cartId = null,
      isResoAssistFlow = false,
      onCallSuccess = () => {},
    } = this.props;

    let data = {};
    data['order_id'] = orderId;
    data['called_to'] = calledTo;
    data['called_to_type'] = calledToType;
    if (isNewUser) {
      data['user_id'] = userId;
    }
    if (valetId && role === riderRoles.BUDDY_RIDER) {
      data['buddy_rider_fe_id'] = valetId;
      data['callee_role'] = riderRoles.BUDDY_RIDER;
    }
    data['is_reso_assist_flow'] = isResoAssistFlow;

    this.setState({
      isDisabled: true,
    });

    const SendCallEvent = ({ success = false }) => {
      if (sendJumboEvent && jumboEventFunc) {
        jumboEventFunc({
          [MetricsForJumboEvent.order_id]: orderId,
          [MetricsForJumboEvent.cart_id]: cartId,
          [MetricsForJumboEvent.customer_id]: userId,
          [MetricsForJumboEvent.feature_meta]: {
            success,
            called_to: calledTo,
            called_to_type: calledToType,
            role: role,
            ...(JumboEventProperties || {}),
            is_via_reso_assist_flow: isResoAssistFlow,
          },
        });
      }
    };

    return wfhModel
      .makeCall(data, isUser, isOfse, isAltContact, role)
      .then((res) => {
        if (res && res.success === true) {
          SendCallEvent({ success: true });
          let msg = res.message ? res.message : 'Call requested successfully';
          this.openToast(false, msg, 'success', false);
          onCallSuccess();
        } else {
          SendCallEvent({ success: false });
          this.openToast(
            false,
            res?.message || 'Something went wrong!',
            'error',
            false,
          );
        }
      })
      .catch((err) => {
        SendCallEvent({ success: false });
        let msg = (err && err.message) || 'Something went wrong!';
        this.openToast(false, msg, 'error', false);
      });
  };

  selectOption = (selectedOption) => {
    this.setState({
      selectedOption: selectedOption,
    });
  };

  render() {
    const { showWfhPop, isDisabled, callAlertData, loader } = this.state;
    const {
      pos = 'top',
      isAltContact = false,
      altContactMissing = false,
      showTooltip = true,
      isCallingDisabled = false,
      callingDisabledReason = '',
    } = this.props;

    return (
      <div className=''>
        <ToolTip
          placement={pos}
          content={
            isCallingDisabled
              ? callingDisabledReason || 'Calling is disabled'
              : 'Click to call'
          }
          disabled={!showTooltip}
        >
          <div>
            <Call
              size={16}
              onClick={this.showWfhCallPop}
              className='tw-cursor-pointer tw-p-2'
              data-dd-action-name='Initiate Call'
              color={
                isCallingDisabled
                  ? grey.z300
                  : isAltContact || altContactMissing
                  ? '#318616'
                  : grey.z300
              }
              fill={isAltContact || altContactMissing ? '#318616' : grey.z300}
            />
          </div>
        </ToolTip>

        {showWfhPop ? (
          <Confirm
            show={showWfhPop}
            content={callAlertData}
            close={this.closeWfhPop}
            handleClick={this.handleClick}
            isDisabled={isDisabled || isCallingDisabled}
            selectOption={this.selectOption}
            loader={loader}
          />
        ) : null}
      </div>
    );
  }
}
